<template>
  <section
    v-if="fn_IS_DOCTOR()"
    class="toggle-telemedicine"
    @click="!telemedicineOffice && showAlert()"
  >
    <dr-switch
      :is-checked.sync="isChecked"
      :value-checked="true"
      :value-unchecked="false"
      label-checked="Online para telemedicina"
      label-unchecked="Offline para telemedicina"
      id="toggle-telemedicine-switch"
      :class="(isLoading || !telemedicineOffice) && 'toggle-telemedicine--disabled'"
      class="toggle-telemedicine__switch"
      @on-check="checkTelemedicine"
    />
  </section>
</template>

<script>
import DrSwitch from '@/components/form/switch'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'DrToggleTelemedicine',

  components: {
    DrSwitch
  },

  data () {
    return {
      isLoading: false,
      isChecked: false
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices',
      appIntegration: 'getAppIntegration'
    }),

    telemedicineOffice () {
      const office = this.offices.find(office => /telemedicine/gi.test(office.type))
      return office || null
    }
  },

  created () {
    window.addEventListener('beforeunload', this.setTelemedicineOffline)

    EventBus.$on('set-telemedicine-offline', this.setTelemedicineOffline)

    this.init()
  },

  methods: {
    init () {
      this.isChecked = this.telemedicineOffice
        ? this.telemedicineOffice['doctor_office_telemedicine']['is_online']
        : false
    },

    checkTelemedicine (status) {
      if (this.telemedicineOffice) {
        if (status !== this.isChecked) {
          this.setTelemedicineStatus(status)
          this.isChecked = status
        }
      } else {
        this.showAlert()
        this.init()
      }
    },

    showAlert () {
      this.$store.dispatch('setModalConfirm', {
        title: 'Atenção',
        body: `Para poder deixar seu consultório online para consultas
          telemedicina, você precisa primeiro fazer a integração com o
          aplicativo Dr. Conecta.`,
        confirmText: 'Integrar com o aplicativo',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.$router.push({ name: 'DoctorAppIntegration' })
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md1',
        active: true
      })
    },

    showConfirmationMessage (status) {
      const msg = status
        ? `Seu consultório virtual está online e você
          está habilitado para receber consultas por telemedicina.`
        : `Seu consultório virtual está offline.`

      this.$store.dispatch('setModalAlert', {
        title: 'Sucesso',
        body: msg,
        size: 'md',
        active: true
      })
    },

    setTelemedicineStatus (status) {
      const suffix = status ? 'online' : 'offline'
      const url = `/doctor/doctor_office_telemedicine/${this.telemedicineOffice.id}/${suffix}`
      const method = 'put'
      const { headers } = this.$store.getters.getAuthHeader

      this.fn_SHOW_PROGRESS()
      this.isLoading = true
      this.$http({ url, method, headers })
        .then(this.fn_GET_DOCTOR)
        .then((res) => {
          const facetofaceOffices = res['doctor_offices']
            .filter(o => /facetoface/gi.test(o.type))

          const telemedicineOffices = res['doctor_offices']
            .filter(o => /telemedicine/gi.test(o.type))

          this.$store.dispatch(
            'setUserOffices',
            [...facetofaceOffices, ...telemedicineOffices] || []
          )
          this.showConfirmationMessage(status)
        })
        .catch(this.fn_HANDLE_ERROR)
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.isLoading = false
        })
    },

    setTelemedicineOffline (event) {
      return new Promise((resolve) => {
        if (this.telemedicineOffice['doctor_office_telemedicine']['is_online']) {
          const url = `/doctor/doctor_office_telemedicine/${this.telemedicineOffice.id}/offline`
          const method = 'put'
          const { headers } = this.$store.getters.getAuthHeader

          this.$http({ url, method, headers })
            .then(resolve)
        }

        resolve()
      })
    }
  }
}
</script>
